import React from 'react';
import { Fragment } from "react"
import classes from './Header.module.css';
import { Button, Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import IconButton from "@mui/material/IconButton";
import { AccountCircle } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { UserContext } from "../../hooks/UserContext";
import { useState, useEffect, useRef, useContext, createRef } from 'react';
import { getName, getEmail, isAuthenticatedUser } from '../../authfile';
import { ADMIN, AUDITLOGS, CONFIGURABLE, DASHBOARD, INTERNALTRACKER, TECHNICIAN, WORKBENCH, adminRouteToPageMapper, technicianRouteToPageMapper } from '../../constants/routeConstants';
import { adminRouteConstants, technicianRouteConstants } from '../../constants/routeConstants';

const Header = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const color = '#ff6a00';
    const email = getEmail();
    const name = getName();
    const isAuthenticated = isAuthenticatedUser();

    const { userRole } = useContext(UserContext);
    const routeConstants = userRole === ADMIN ? adminRouteConstants : technicianRouteConstants;
    const routeToPage = userRole === ADMIN ? adminRouteToPageMapper : technicianRouteToPageMapper;
    const [menuUsr, setMenuUsr] = React.useState(null);
    const openUsr = Boolean(menuUsr);
    const heading = () => {
        if (userRole == ADMIN) {
            if (pathname == "/") {
                return "Dashboard";
            }
            if (pathname == "/workbench") {
                return "Case Assignment";
            }
            if (pathname == "/configurable") {
                return "Configurable Screen"
            }
        } else if (userRole == TECHNICIAN) {
            if (pathname == "/home") {
                return "Dashboard";
            }
            if (pathname == "/workbench" || pathname == "/") {
                return "My Workbench";
            }
            if (pathname == "/configurable") {
                return "Configurable Screen"
            }
        }
    }
    const handleClickUsr = (event) => {
        setMenuUsr(event.currentTarget);
    };
    const handleCloseUsr = (event) => {
        setMenuUsr(null);
    };

    const handleLogout = (event) => {
        setMenuUsr(null);
        // const logoutRequest = {
        //     account: userDetail,
        //     postLogoutRedirectUri: process.env.REACT_APP_URL,
        // };
        // instance.logoutRedirect(logoutRequest);
    };

    return (
        <div className={classes.header}>
            <div className={classes.welcomeHeading}>
                <Stack className="headerPanel" direction="row" spacing={0}>
                    <div className="headerDiv">
                        {isAuthenticated ? (
                            <div className="userSpan">
                                <Typography>

                                    Welcome {name} ({userRole})
                                    <IconButton
                                        className="iconBtn"
                                        onClick={handleClickUsr}
                                    >
                                        <AccountCircle className="userIcon" />
                                    </IconButton>
                                </Typography>

                                <Menu anchorEl={menuUsr} open={openUsr} onClose={handleCloseUsr}>
                                    <MenuItem className="menuList" onClick={handleCloseUsr}>
                                        {email}
                                    </MenuItem>
                                    <MenuItem className="menuList" onClick={handleCloseUsr}>
                                    </MenuItem>
                                    {/* <Divider />
                                    <MenuItem className="menuList" onClick={handleLogout}>
                                        <ListItemIcon>
                                            <Logout fontSize="small" />
                                        </ListItemIcon>
                                        Logout
                                    </MenuItem> */}
                                </Menu>
                            </div>
                        ) : (
                            <Typography className="userSpan">
                                <IconButton>
                                    <AccountCircle className="userIcon" />
                                </IconButton>
                            </Typography>
                        )}
                    </div>
                </Stack>

            </div>
            <div className={classes.dashboard}>
                <div className={classes.dashboardHeading}>
                    <Typography variant="p" sx={{ color: '#ffffff', fontSize: '1.2rem' }}>{routeConstants[routeToPage[pathname]].title}</Typography>
                </div>
                <div className={classes.dashboardLinks}>
                    <Button variant="contained" onClick={() => navigate(routeConstants[DASHBOARD].route)} sx={{ mx: 1, color: routeToPage[pathname] === DASHBOARD ? "#ff612b" : "primary" }}>Dashboard</Button>
                    <Button variant="contained" onClick={() => navigate(routeConstants[WORKBENCH].route)} sx={{ mx: 1, color: routeToPage[pathname] === WORKBENCH ? "#ff612b" : "primary" }}>{userRole == ADMIN ? "Case Assignment" : "Workbench"}</Button>
                    {
                        userRole === ADMIN && 
                        <Fragment>
                            <Button variant="contained" onClick={() => navigate(routeConstants[INTERNALTRACKER].route)} sx={{ mx: 1,color: routeToPage[pathname] === INTERNALTRACKER ? "#ff612b" : "primary" }}>Internal Tracker System</Button>
                            <Button variant="contained" onClick={() => navigate(routeConstants[CONFIGURABLE].route)} sx={{ mx: 1, color: routeToPage[pathname] === CONFIGURABLE ? "#ff612b" : "primary" }}>Configurable Screen</Button>
                            <Button variant="contained" onClick={() => navigate(routeConstants[AUDITLOGS].route)} sx={{ mx: 1, color: routeToPage[pathname] === AUDITLOGS ? "#ff612b" : "primary" }}>Audit Logs</Button>
                        </Fragment>
                    }
                </div>
            </div>
        </div>
    )
}

export default Header;